/**
 * API module
 * Notes events module.
 */
import { ApiModule } from "@/api/api-module";
import routes from "./routes";

export class NotesApi extends ApiModule {
  init(todayDate) {
    let _out = [];
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .get(apiPath + `?max_date=${todayDate.max}&ordering=-date`)
        .then(response => {
          if (response.status === 200 && response.data) {
            this.http
              .get(apiPath + `?min_date=${todayDate.min}&ordering=date`)
              .then(res => {
                if (res.status === 200 && res.data) {
                  _out["min_date"] = res.data;
                  _out["max_date"] = response.data;
                  resolve(_out);
                }
              })
              .catch(error => {
                console.error("min_date error ", error);
              });
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getMaxDate(todayDate) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .get(apiPath + `?max_date=${todayDate}&ordering=-date`)
        .then(response => {
          if (response.status == 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getMinDate(todayDate) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .get(apiPath + `?min_date=${todayDate}&ordering=date`)
        .then(response => {
          if (response.status == 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  addNotes(query) {
    if (!query) {
      return;
    }
    return new Promise((resolve, reject) => {
      let apiPath = routes.index + query;
      this.http
        .get(apiPath)
        .then(response => {
          if (response.status == 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  setNote(data) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .post(apiPath, data)
        .then(response => {
          if (response.status === 201 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  deleteNote(id) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .delete(apiPath + `${id}/`)
        .then(response => {
          if (response.status === 204) {
            resolve(response.data);
          } else if(response.status === 404) {
            resolve(response.status)
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  updateNote(note) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .put(apiPath + `${note.id}/`, note)
        .then(response => {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  searchNotes(request) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .get(apiPath + `?search=${request}`)
        .then(response => {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getNextPage(url) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      let _query = apiPath + "?" + url.split("?")[1];
      this.http
        .get(_query)
        .then(response => {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          } else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getNotesByRange(range, short) {
    return new Promise((resolve, reject) => {
      let apiPath = routes.index;
      this.http
        .get(apiPath + `?min_date=${range.start}&max_date=${range.end}&offset=0&limit=${short ? 31 : 10}&${short ? 'short=1' : ''}`)
        .then(response => {
          if (response.status === 200 && response.data) {
            resolve(response.data);
          }else {
            reject("Error occurres while loading data from server");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

// Create and export module class instance.
const notesApi = new NotesApi("notes");

export default notesApi;



// WEBPACK FOOTER //
// ./src/apps/bpm/notes/api/index.js